"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createBreakpoints = _interopRequireDefault(require("../../styles/createBreakpoints"));
var _createSpacing = _interopRequireDefault(require("../../styles/createSpacing"));
var _spacing = _interopRequireDefault(require("../busbud/tokens/spacing"));
var _breakpoints = _interopRequireDefault(require("./tokens/breakpoints"));
var _fontWeight = _interopRequireDefault(require("./tokens/fontWeight"));
const breakpoints = (0, _createBreakpoints.default)(_breakpoints.default);
const spacing = (0, _createSpacing.default)(_spacing.default.base);
const base = {
  breakpoints,
  fontWeight: _fontWeight.default,
  spacing
};
var _default = exports.default = base;